import { render, staticRenderFns } from "./Fanzone.vue?vue&type=template&id=7822f7be"
import script from "./Fanzone.vue?vue&type=script&lang=js"
export * from "./Fanzone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports